// function formatSeconds(s: number) {

//   return (s - (s %= 60)) / 60 + (s > 9 ? ':' : ':0') + s;
// }

// export default formatSeconds;

const formatSeconds = (s: number) => {
  const seconds = s % 60;
  const minutes = (s - seconds) / 60;
  const paddedSeconds = seconds > 9 ? seconds.toString() : `0${seconds}`;

  return `${minutes}m:${paddedSeconds}s`;
};

export default formatSeconds;
